import { render, staticRenderFns } from "./hotPanelCard.vue?vue&type=template&id=5f708d8a&scoped=true"
import script from "./hotPanelCard.vue?vue&type=script&lang=js"
export * from "./hotPanelCard.vue?vue&type=script&lang=js"
import style0 from "./hotPanelCard.vue?vue&type=style&index=0&id=5f708d8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f708d8a",
  null
  
)

export default component.exports